import React, { memo, useState } from 'react';
import validators from 'investira.sdk/lib/utils/validators';
import {
  Stack,
  Typography,
  Skeleton,
  Menu,
  MenuItem,
  Card,
  Icon,
  CardHeader,
  Tooltip,
  CardContent,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Chip,
  IconButton,
  ListItemText,
  ListSubheader,
  LoadingButton,
  Divider
} from 'investira.react.components';
import { formats } from 'investira.sdk';
import { Link } from 'react-router-dom';
import Highlights from './Highlights';
import CarteirasChart from './CarteirasChart';
import Graphs from '../Graphs';
import DonutChart from '../../../../components/molecules/DonutChart';
import { DatePicker } from '../../../../components/molecules';
import { shortname } from '../../../../utils/typo';
import useDashboard from '../../../../hooks/useDashboard';
const Posicao = memo(() => {
  const { posicao } = useDashboard();
  const { filters, state, data, actions } = posicao;
  const { views = [], selectedView, availableDates = [], selectedDate } = filters;
  const { isInitialLoading, isLoadingViews, isLoadingDates, error, lastUpdated } = state;
  const { highlights, carteirasChart = [], carteirasTable = [], charts } = data;
  const [anchorEl, setAnchorEl] = useState(null);

  // const xIndicadores = useMemo(() => {
  //   const xIndicadoresFlatted = Object.values(indicadores || {}).flatMap(
  //     (pLevel) => (Array.isArray(pLevel) ? pLevel : Object.values(pLevel)),
  //   );

  //   const xIndicadoresFiltered = xIndicadoresFlatted
  //     .filter((xIndicador) => {
  //       return ['DI', 'USD', 'IPCA', 'IGPM', 'INPC', 'IBOV', 'IMAB', 'IFIX'].includes(
  //         xIndicador.indicador_id
  //       );
  //     })
  //     .map((xIndicador) => {
  //       const { indicador, indicador_id } = xIndicador;
  //       return { indicador, indicador_id };
  //     });

  //   return xIndicadoresFiltered;
  // }, [indicadores]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSelectView = pView => {
    actions.selectView(pView);
    handleMenuClose();
  };
  const hasSelectableViews = views.length > 0;
  const favoriteView = views.find(view => view.isCarteirasFavoritas) || null;
  const portfolioViews = views.filter(view => !view.isCarteirasFavoritas);
  const displayView = selectedView || favoriteView || views[0] || null;
  if (!hasSelectableViews && !isLoadingViews) {
    return null;
  }
  return (
    <>
      <Divider />
      <Stack
        gap={2}
        component="section"
        sx={{
          gap: 3
        }}
        flexGrow={1}
        direction="column">
        <Stack gap={2}>
          <Stack
            direction={{
              sm: 'column',
              md: 'row'
            }}
            alignItems={{
              sm: 'flex-start',
              md: 'flex-end'
            }}
            justifyContent="space-between"
            gap={2}>
            <Stack
              direction={{
                xs: 'column',
                sm: 'row'
              }}
              alignItems={{
                xs: 'flex-start',
                sm: 'center'
              }}
              gap={{
                xs: 2,
                sm: 4
              }}>
              <Stack direction="column" gap={0.75}>
                <Typography variant="caption" color="textSecondary">
                  Visão
                </Typography>
                <Stack>
                  <LoadingButton
                    variant="outlined"
                    color="primary"
                    // size="small"
                    sx={{
                      px: 2,
                      minWidth: 220,
                      minHeight: 40,
                      justifyContent: 'flex-start'
                    }}
                    onClick={event => setAnchorEl(event.currentTarget)}
                    startIcon={
                      <Icon
                        iconName={displayView?.isCarteirasFavoritas ? 'star5' : 'portofolio'}
                        size={16}
                      />
                    }
                    loading={isLoadingViews}
                    disabled={!isLoadingViews && (!hasSelectableViews || isInitialLoading)}>
                    {displayView?.portfolio || ' '}
                  </LoadingButton>
                  <Menu
                    id="view-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}>
                    {favoriteView && (
                      <MenuItem
                        key={favoriteView.portfolio_id}
                        onClick={() => handleSelectView(favoriteView)}
                        dense>
                        <ListItemText>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={2}>
                            {favoriteView.portfolio}
                            <Tooltip title="Quantidade de Carteiras">
                              <span>
                                <Chip
                                  variant="outlined"
                                  size="small"
                                  color="primary"
                                  label={favoriteView.quantidade_carteiras}
                                  icon={<Icon iconName="wallet" color="primary" size={14} />}
                                  sx={{
                                    px: 1,
                                    minWidth: '60px'
                                  }}
                                />
                              </span>
                            </Tooltip>
                          </Stack>
                        </ListItemText>
                      </MenuItem>
                    )}
                    {favoriteView && portfolioViews.length > 0 && <Divider />}
                    {portfolioViews.length > 0 && (
                      <ListSubheader disableSticky muiSkipListHighlight>
                        Portfólios
                      </ListSubheader>
                    )}
                    {portfolioViews.map(xView => (
                      <MenuItem
                        key={xView.portfolio_id}
                        onClick={() => handleSelectView(xView)}
                        dense>
                        <ListItemText>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={2}>
                            {xView.portfolio}
                            <Tooltip title="Quantidade de Carteiras">
                              <span>
                                <Chip
                                  variant="outlined"
                                  size="small"
                                  color="primary"
                                  label={xView.quantidade_carteiras}
                                  icon={<Icon iconName="wallet" color="primary" size={14} />}
                                  sx={{
                                    px: 1,
                                    minWidth: '60px'
                                  }}
                                />
                              </span>
                            </Tooltip>
                          </Stack>
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>
                </Stack>
              </Stack>
              <Stack direction="column" gap={0.75}>
                <Typography variant="caption" color="textSecondary">
                  Data posição
                </Typography>
                <Stack>
                  {isLoadingDates ? (
                    <Skeleton
                      variant="rectangular"
                      width={220}
                      height={40}
                      sx={{
                        borderRadius: 2
                      }}
                    />
                  ) : (
                    <DatePicker
                      value={selectedDate}
                      onChange={pDate => pDate && actions.selectDate(pDate)}
                      availableDates={availableDates}
                      disabled={!selectedView || availableDates.length === 0 || isInitialLoading}
                      selectionOnly
                      slotProps={{
                        textField: {
                          variant: 'outlined',
                          size: 'small',
                          margin: 'dense',
                          sx: { margin: 0 }
                        }
                      }}
                    />
                  )}
                </Stack>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" gap={2}>
              {isInitialLoading ? (
                <Skeleton
                  variant="rectangular"
                  width={220}
                  height={30}
                  sx={{
                    borderRadius: 2
                  }}
                />
              ) : (
                lastUpdated && (
                  <Typography variant="body2" color="textSecondary">
                    {`Última atualização: ${formats.formatDateCustom(
                      lastUpdated,
                      'DD/MM/YYYY, HH:mm'
                    )}`}
                  </Typography>
                )
              )}
              <Tooltip title={'Atualizar'}>
                <IconButton color={'primary'} onClick={actions.refetch} disabled={isInitialLoading}>
                  <Icon size={21} iconName={'refresh'} />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography variant="h6" color="textPrimary" component="h3">
              Posição
            </Typography>
            {error?.message && (
              <Typography variant="caption" color="error">
                {error.message}
              </Typography>
            )}
          </Stack>
          <Stack direction="column" justifyContent="space-between" gap={1.5}>
            <Stack
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(1, 1fr)',
                  md: 'repeat(1, 1fr)',
                  lg: 'repeat(2, 1fr)',
                  xl: 'repeat(2, 1fr)'
                },
                gap: 1.5
              }}>
              <Stack display="flex" direction="column" gap={1.5}>
                {isInitialLoading ? (
                  <>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="20%"
                      sx={{
                        borderRadius: 2
                      }}
                    />
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="80%"
                      sx={{
                        borderRadius: 2
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Highlights isLoading={false} data={highlights} />
                    <Card
                      sx={{
                        flex: 1,
                        minHeight: 0
                      }}>
                      <CardHeader
                        title={
                          <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" alignItems="center" gap={2}>
                              <Icon iconName="wallet" color="secondaryLightness" size={24} />
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  fontWeight: 600
                                }}>
                                Carteiras
                              </Typography>
                            </Stack>
                          </Stack>
                        }
                      />
                      <CardContent>
                        <Stack
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                              xs: 'repeat(1, 1fr)',
                              md: 'repeat(1, 1fr)',
                              lg: 'repeat(1, 1fr)',
                              xl: 'repeat(1, 1fr)'
                            },
                            alignItems: 'center',
                            gap: 1.5
                          }}>
                          <CarteirasChart data={carteirasChart} />
                          <TableContainer
                            id="table-container"
                            sx={{
                              overflow: 'auto',
                              maxHeight: '275px',
                              paddingRight: 2
                            }}>
                            <Table
                              sx={{
                                minWidth: 400
                              }}
                              size="small"
                              tableLayout="fixed">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    align="left"
                                    minWidth="100px"
                                    sx={{
                                      pr: 0
                                    }}
                                  />
                                  <TableCell
                                    sx={{
                                      position: 'sticky',
                                      left: 0,
                                      zIndex: 1,
                                      backgroundColor: theme => theme.palette.secondary.dark
                                    }}>
                                    <Typography variant="caption" color="textSecondary" noWrap>
                                      Carteira
                                    </Typography>
                                  </TableCell>
                                  <TableCell colSpan={2} align="left" minWidth="100px">
                                    <Typography variant="caption" color="textSecondary" noWrap>
                                      Última Posição
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="right" minWidth="100px">
                                    <Typography variant="caption" color="textSecondary" noWrap>
                                      Total Financeiro (R$)
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="right" minWidth="100px">
                                    <Typography variant="caption" color="textSecondary" noWrap>
                                      Part. (%)
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {carteirasTable.length > 0 &&
                                  carteirasTable.map(xCarteira => {
                                    const xIsAberta = validators.isTrue(xCarteira.aberta);
                                    return (
                                      <TableRow
                                        key={xCarteira.carteira_id}
                                        sx={{
                                          '&:last-child td, &:last-child th': {
                                            border: 0
                                          }
                                        }}>
                                        <TableCell
                                          align="left"
                                          minWidth="60px"
                                          sx={{
                                            pr: 0
                                          }}>
                                          <DonutChart
                                            id={xCarteira.carteira_id}
                                            startAngle={xCarteira.startAngle}
                                            endAngle={xCarteira.endAngle}
                                            sx={{
                                              width: 40,
                                              height: 40
                                            }}
                                            serie={{
                                              financeiro: xCarteira.financeiroAcumulado,
                                              total:
                                                (highlights?.total_financeiro || 0) +
                                                xCarteira.financeiroAcumulado
                                            }}
                                            percentual={formats.formatNumber(
                                              xCarteira.percentual,
                                              0
                                            )}
                                            index={0}
                                          />
                                        </TableCell>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          sx={{
                                            position: 'sticky',
                                            left: 0,
                                            zIndex: 1,
                                            backgroundColor: theme => theme.palette.secondary.dark
                                          }}>
                                          <Typography
                                            component={Link}
                                            to={`/carteiras/${xCarteira.carteira_id}`}
                                            color="primary"
                                            variant="body2"
                                            target="_blank">
                                            {shortname(xCarteira.carteira, 25)}
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left" minWidth="100px">
                                          {xCarteira.data
                                            ? formats.formatDate(xCarteira.data)
                                            : '--'}
                                        </TableCell>
                                        <TableCell align="left">
                                          {xCarteira.data && (
                                            <Tooltip title={xIsAberta ? 'Aberta' : 'Fechada'}>
                                              <IconButton
                                                color={xIsAberta ? 'warning' : 'success'}
                                                size="small">
                                                <Icon
                                                  iconName={xIsAberta ? 'box_3d_open' : 'box_3d'}
                                                  size={18}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        </TableCell>
                                        <TableCell align="right" minWidth="100px">
                                          {xCarteira.financeiro > 0
                                            ? formats.formatNumber(xCarteira.financeiro, 2, true)
                                            : '--'}
                                        </TableCell>
                                        <TableCell align="right" minWidth="100px">
                                          {xCarteira.percentual
                                            ? formats.formatNumber(xCarteira.percentual, 2)
                                            : '--'}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Stack>
                      </CardContent>
                    </Card>
                  </>
                )}
              </Stack>
              <Graphs isLoading={isInitialLoading} data={charts} />
            </Stack>
            {/* <Stack
             sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(3, 1fr)',
                xl: 'repeat(3, 1fr)'
              },
              gap: 1.5,
              mt: 2
             }}>
             {isLoading ? (
              Array.from({ length: 3 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width="100%"
                  height="260px"
                  sx={{ borderRadius: 2 }}
                />
              ))
             ) : (
              <>
                <Card
                  sx={{
                    flex: 1,
                    minHeight: 0
                  }}>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Icon iconName="report" color="secondaryLightness" size={21} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                          Últimos Relatórios
                        </Typography>
                      </Stack>
                    }
                  />
                  <CardContent>
                    <Stack spacing={1}>
                      {Object.values(OUTPUT)
                        .filter(output =>
                          ['RLDUR', 'RLVAR', 'RLENQ', 'RLSTT', 'RLCNC'].includes(output.output_id)
                        )
                        .map((output, index) => (
                          <Stack direction="column" spacing={1}>
                            <Typography variant="body2" color="textSecondary">
                              {output.descricao}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between">
                              <Typography
                                component={Link}
                                to={`/carteiras/${xCarteiras[index]?.carteira_id}`}
                                color="primary"
                                variant="body2"
                                target="_blank">
                                {shortname(xCarteiras[index]?.carteira || '', 25)}
                              </Typography>
                              <Typography variant="body2">
                                {xCarteiras[index]?.carteira &&
                                  formats.formatDate(dates.addDays(new Date(), -index))}
                              </Typography>
                            </Stack>
                          </Stack>
                        ))}
                      <Typography variant="body2" color="textSecondary">
                          Duration
                        </Typography>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Typography variant="body2">Carteira</Typography>
                          <Typography variant="body2">{formats.formatDate(new Date())}</Typography>
                        </Stack>
                      <Tooltip title="Visualizar">
                          <Link to={`#`} target="_blank">
                            <IconButton color="primary">
                              <Icon iconName="eye" size={18} />
                            </IconButton>
                          </Link>
                        </Tooltip>
                    </Stack>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    flex: 1,
                    minHeight: 0
                  }}>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Icon iconName="report" color="secondaryLightness" size={21} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                          Enquadramentos
                        </Typography>
                      </Stack>
                    }
                  />
                  <CardContent>
                    <Stack spacing={2}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Stack direction="column" spacing={0.5}>
                          <Typography variant="h4" fontWeight={600}>
                            {`3/${xCarteiras.length}`}
                          </Typography>
                          <Typography variant="body2">Carteiras</Typography>
                        </Stack>
                        <Stack>
                          <DonutChart
                            id="enquadramento"
                            serie={{
                              desenquadradas: 3,
                              total: xCarteiras.length - 3
                            }}
                            percentual={formats.formatNumber((3 / xCarteiras.length) * 100, 0)}
                            index={0}>
                            <Typography variant="h4">
                              {formats.formatNumber((3 / xCarteiras.length) * 100, 0)}%
                            </Typography>
                          </DonutChart>
                        </Stack>
                      </Stack>
                      <Stack spacing={1.5}>
                        <Typography variant="body2" color="textSecondary">
                          Desenquadradas
                        </Typography>
                        <Stack spacing={1}>
                          {xCarteiras.slice(0, 3).map(xCarteiraList => {
                            return (
                              <Stack
                                key={xCarteiraList.carteira_id}
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between">
                                <Typography
                                  component={Link}
                                  to={`/carteiras/${xCarteiraList.carteira_id}`}
                                  color="primary"
                                  // rel="noopener noreferrer"
                                  variant="body2"
                                  target="_blank">
                                  {shortname(xCarteiraList.carteira, 25)}
                                </Typography>
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Typography variant="body2">
                                    {`${Math.floor(Math.random() * 5)} de ${Math.floor(
                                      Math.random() * 20
                                    )} regras`}
                                  </Typography>
                                  <Tooltip title="Visualizar">
                                      <Link to={`#`} target="_blank">
                                        <IconButton color="primary">
                                          <Icon iconName="eye" size={18} />
                                        </IconButton>
                                      </Link>
                                    </Tooltip>
                                </Stack>
                              </Stack>
                            );
                          })}
                        </Stack>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    flex: 1,
                    minHeight: 0
                  }}>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Icon iconName="report" color="secondaryLightness" size={21} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                          Conferências
                        </Typography>
                      </Stack>
                    }
                  />
                  <CardContent>
                    <Stack spacing={2}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Stack direction="column" spacing={0.5}>
                          <Typography variant="h4" fontWeight={600}>
                            {`4/${xCarteiras.length}`}
                          </Typography>
                          <Typography variant="body2">Carteiras</Typography>
                        </Stack>
                        <Stack>
                          <InfoBar value={50}>
                            <Typography variant="h4">
                              {formats.formatNumber((4 / xCarteiras.length) * 100, 0)}%
                            </Typography>
                          </InfoBar>
                          <DonutChart
                            id="conferencias"
                            serie={{
                              divergentes: 4,
                              total: xCarteiras.length - 4
                            }}
                            percentual={formats.formatNumber((4 / xCarteiras.length) * 100, 0)}
                            index={0}>
                            <Typography variant="h4">
                              {formats.formatNumber((3 / xCarteiras.length) * 100, 0)}%
                            </Typography>
                          </DonutChart>
                        </Stack>
                      </Stack>
                      <Stack spacing={1.5}>
                        <Typography variant="body2" color="textSecondary">
                          Com divergências
                        </Typography>
                        <Stack spacing={1}>
                          {xCarteiras.slice(0, 4).map(xCarteiraList => {
                            const statusList = Object.values(CONFERENCIA_CUSTODIANTE_STATUS).filter(
                              xStatus => xStatus.id !== 'OK'
                            );
                            const randomStatus =
                              statusList[Math.floor(Math.random() * statusList.length)];
                            return (
                              <Stack
                                key={xCarteiraList.carteira_id}
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between">
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Icon
                                    iconName="information"
                                    size={16}
                                    color={randomStatus.color}
                                  />
                                  <Typography
                                    component={Link}
                                    to={`/carteiras/${xCarteiraList.carteira_id}`}
                                    color="primary"
                                    variant="body2"
                                    target="_blank">
                                    {shortname(xCarteiraList.carteira, 25)}
                                  </Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Typography variant="body2">{randomStatus.descricao}</Typography>
                                  <Tooltip title={randomStatus.descricao}>
                                      <IconButton color={randomStatus.color}>
                                        <Icon iconName="information" size={16} />
                                      </IconButton>
                                    </Tooltip>
                                  <Chip
                                      label={randomStatus.descricao}
                                      color={randomStatus.color}
                                      size="small"
                                      sx={{ px: 1, width: '120px' }}
                                      variant="outlined"
                                    />
                                  <Tooltip title="Visualizar">
                                      <Link to={`#`} target="_blank">
                                        <IconButton color="primary">
                                          <Icon iconName="eye" size={18} />
                                        </IconButton>
                                      </Link>
                                    </Tooltip>
                                </Stack>
                              </Stack>
                            );
                          })}
                        </Stack>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </>
             )}
             </Stack> */}
            {/* <Card
             sx={{
              flex: 1,
              minHeight: 0,
             }}
             >
             <CardHeader
              title={
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Títulos a Vencer
                </Typography>
              }
             />
             </Card> */}
          </Stack>
        </Stack>
        {/* <Stack flexGrow={1}>
         <PosicaoEvolucaoChart key={carteirasTable?.length} posicoes={carteirasTable} />
         </Stack> */}
      </Stack>
    </>
  );
});
export default Posicao;
